<app-notification-banner *ngIf="!IsNotificationExist"
  (IsMaintenanceAlert)="GetMaintenanceAlertNotificationMessage($event)"></app-notification-banner>

<div class="loader_cls" id="loaderForServiceCall" style="display:none;">
  <div class="app-loader"></div>

  <label id="calculateID" class="">We are calculating your change. This may take a moment...</label>
  <label id="UpdateID" class="">Updating your request. Please wait for a moment...</label>
  <label id="GettingID" class="">Getting your request. Please wait for a moment...</label>
  <label id="GettingReportClaimID" class="">Please wait while we are submitting your claim...</label>

</div>
<!-- Page Wrapper -->
<div id="wrapper">

  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column">
    <!-- Main Content -->
    <div id="content">
      <app-header [hidden]="currentPath==='/overview' || currentPath==='/login'" [notification]="notification">
      </app-header>

    </div>
    <div *ngIf="(auth.isAuthenticated$ | async)"> 
      <!-- Notification content -->
      <div *ngIf="!IsMaintenanceAlertExist">
        <app-notification-banner (IspageDisable)="GetNotificationMessage($event)"></app-notification-banner>
        <div *ngIf="(auth.isAuthenticated$ | async) && IsNotificationExist">
          <app-footer></app-footer>
        </div>
      </div>
     
      </div>
      <!-- Begin Page Content -->
      <div *ngIf="!IsNotificationExist">
        <div class="container min_height_container">
          <div class="row">
            <div
              class="{{currentPath==='/' || currentPath==='/overview' || currentPath==='/login' || currentPath==='/landing'?'col-lg-12 p-0':'col-lg-12 '}}">
              <router-outlet (activate)="routeChange()"></router-outlet>
              <p-dialog header="Error Notification" [(visible)]="dao.showErrorPopup" (onHide)="dao.showErrorPopup=false;"
                [baseZIndex]="10000" [draggable]="false" [resizable]="false" [closable]="true" [modal]="true"
                styleClass="EditMailingPopUp MailingPopUp">
                <div class="row mt-2">
                  <div class="col-lg-12">
                    <span class="extendPriorDateLabel confirmTxt">Information regarding your request has been captured and
                      is being forwarded to our Support Center team for review. A team member will be in touch as soon as
                      possible. You may also contact us directly at 844-462-3600 or
                      <a href="mailto:claims@berkleymarine.com">xpressrequest&#64;berkleymarine.com</a> with any questions or
                      concerns.</span>
                  </div>
                </div>
                <div class="row float-right mt-3">
                  <button class="policyCloseBtn" (click)="dao.showErrorPopup=false;">Close</button>
                </div>
              </p-dialog>
           </div>

          </div>
        </div>
        <app-footer></app-footer>
    </div>
    <!-- /.container-fluid -->

    <!--Footer Start-->
    <!-- <app-footer></app-footer> -->
  </div>
</div>
<p-confirmDialog [style]="{width: '50vw'}" styleClass="confirmbtn" [baseZIndex]="1000"
  rejectButtonStyleClass="p-button-text"></p-confirmDialog>